export default "__VITE_ASSET__Drx2bLyc__"